module.exports = __webpack_public_path__ + "img/2025-11-17c_2.be1aea98.jpg";